import React from 'react';
import { FacebookIcon, InstagramIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { CONTACT } from '../data/media';
import { Mascot } from './Mascot';
export function Footer() {
  const {
    t
  } = useLanguage();
  const links = [{
    href: '#services',
    label: t.nav.services
  }, {
    href: '#projects',
    label: t.nav.gallery
  }, {
    href: '#about',
    label: t.nav.about
  }, {
    href: '#process',
    label: t.nav.process
  }, {
    href: '#contact',
    label: t.nav.contact
  }, {
    href: '#contact',
    label: t.footer.privacy
  }];
  return <footer className="w-full bg-ink pt-16 lg:pt-20" data-id="element-116" data-mp="3leviv7odbqit">
      <div className="mx-auto max-w-shell px-4 sm:px-6 lg:px-8" data-id="element-117" data-mp="3lggc8tyy53f3">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-118" data-mp="3qcdpgrewxtnn">
          <div className="lg:pr-6" data-id="element-119" data-mp="29yxehh44xsnx">
            <div className="flex items-center gap-3" data-id="element-120" data-mp="29xm1qrsppako">
              <Mascot size={48} tone="dark" animate data-id="element-121" data-mp="2eyt8cnj4c3pr" />
              <span className="font-display text-sm font-extrabold uppercase leading-tight text-white" data-id="element-122" data-mp="2ezl0tphf5lbt">
                Pollo Construction
                <span className="block text-[10px] tracking-[0.22em] text-brand-500" data-id="element-123" data-mp="3gaz3z8yymvmq">
                  &amp; Granite Inc.
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-white/60" data-id="element-124" data-mp="3q8n125k1gf82">{t.footer.about}</p>
            <p className="mt-5 font-display text-xs font-bold uppercase tracking-[0.2em] text-gold-500" data-id="element-125" data-mp="3qazp90ge3ltk">
              {CONTACT.tagline}
            </p>
          </div>

          <nav aria-label={t.footer.quickLinks} data-id="element-126" data-mp="33e5h7zjgmr5">
            <h2 className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-white" data-id="element-127" data-mp="hsk2qqetg2we">
              {t.footer.quickLinks}
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-128" data-mp="cuijo5he43kx">
              {links.map(link => <li key={`${link.href}-${link.label}`} data-id="element-129" data-mp="qub5bme27tm1">
                  <a href={link.href} className="text-sm font-semibold text-white/60 transition-colors duration-200 ease-smooth hover:text-brand-500" data-id="element-130" data-mp="ms6h536drp6s">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-131" data-mp="13sipgwuf3qds">
            <h2 className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-white" data-id="element-132" data-mp="13rpoydm1xx43">
              {t.footer.contact}
            </h2>
            <ul className="mt-5 space-y-3 text-sm" data-id="element-133" data-mp="1cm466lq57hpu">
              <li data-id="element-134" data-mp="1clch7tr1wi8j">
                <a href={`tel:+1${CONTACT.phoneRaw}`} className="inline-flex items-center gap-2 font-semibold text-white/60 transition-colors duration-200 ease-smooth hover:text-brand-500" data-id="element-135" data-mp="1cnytu7sstnxm">
                  <PhoneIcon className="h-4 w-4 text-brand-500" aria-hidden="true" data-id="element-136" data-mp="1rhtwgw2d2h0d" />
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li data-id="element-137" data-mp="3ta86za2ksj6r">
                <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 font-semibold text-white/60 transition-colors duration-200 ease-smooth hover:text-brand-500" data-id="element-138" data-mp="3t9q7m4km9oum">
                  <MailIcon className="h-4 w-4 text-brand-500" aria-hidden="true" data-id="element-139" data-mp="25n3wq8u2qusb" />
                  {CONTACT.email}
                </a>
              </li>
              <li className="font-semibold text-white/60" data-id="element-140" data-mp="1wo8o6q3k58lu">{CONTACT.license}</li>
              <li className="font-semibold text-white/60" data-id="element-141" data-mp="2tdznr3qphlyi">{t.contact.areaValue}</li>
            </ul>
          </div>

          <div data-id="element-142" data-mp="2pbuw2ajtizei">
            <h2 className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-white" data-id="element-143" data-mp="2pdfq7z280gbu">
              {t.footer.follow}
            </h2>
            <div className="mt-5 flex gap-3" data-id="element-144" data-mp="2kf4bpb0zdhna">
              {[{
              id: 'facebook',
              Icon: FacebookIcon,
              href: 'https://facebook.com'
            }, {
              id: 'instagram',
              Icon: InstagramIcon,
              href: 'https://instagram.com'
            }].map(({
              id,
              Icon,
              href
            }) => <a key={id} href={href} target="_blank" rel="noreferrer" aria-label={id} className="inline-flex h-11 w-11 items-center justify-center rounded border border-white/15 text-brand-500 transition-colors duration-200 ease-smooth hover:border-brand-500 hover:bg-brand-500 hover:text-ink" data-id="element-145" data-mp="1414ieiwn4q90">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-146" data-mp="3bjzyrmt0cqds" />
                </a>)}
            </div>
            <a href="#contact" className="mt-6 inline-block rounded bg-brand-500 px-5 py-3 font-display text-xs font-extrabold uppercase tracking-wide text-ink transition-colors duration-200 ease-smooth hover:bg-brand-400" data-id="element-147" data-mp="3flttzfkfp26k">
              {t.nav.quote}
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 py-7 text-xs font-semibold text-white/45 sm:flex-row sm:items-center sm:justify-between" data-id="element-148" data-mp="1q4swwtepavrs">
          <p data-id="element-149" data-mp="1nl68jvs9lhm3">
            © {new Date().getFullYear()} {CONTACT.company}. {t.footer.rights}
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1" data-id="element-150" data-mp="1iltcckfi6y6u">
            <span data-id="element-151" data-mp="1wmdtlc5rsly8">{CONTACT.license}</span>
            <span className="text-brand-500" data-id="element-152" data-mp="1wlcm1hnyqhl9">{t.footer.licensed}</span>
          </p>
        </div>
      </div>
    </footer>;
}